import { useContractInfo } from './hooks';
import { convertToPresentationProps } from './logics';
import { ContractInfoPresentation } from './presentations';

/**
 * ご契約情報 Container
 *
 * 親コンポーネント（Screen）で Suspense にラップすること
 */
export const ContractInfo: React.FC = () => {
  const {
    state: { data, creditCardData, isFormExpanded, errorMessage, successMessage, isSubmitDisabled },
    actions: { handleToggleForm, handleSubmitCard },
  } = useContractInfo();

  const {
    companyInfo,
    planInfo,
    contactInfo,
    billingInfo,
    settlementMethodLabel,
    isCardPayment,
    cardLabel,
  } = convertToPresentationProps({
    data,
    creditCardData,
  });

  return (
    <ContractInfoPresentation
      companyInfo={companyInfo}
      planInfo={planInfo}
      contactInfo={contactInfo}
      billingInfo={billingInfo}
      settlementMethodLabel={settlementMethodLabel}
      isCardPayment={isCardPayment}
      cardLabel={cardLabel}
      isFormExpanded={isFormExpanded}
      errorMessage={errorMessage}
      successMessage={successMessage}
      isSubmitDisabled={isSubmitDisabled}
      onToggleForm={handleToggleForm}
      onSubmitCard={handleSubmitCard}
    />
  );
};
